var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.536 18C4.1136 18 3.75213 17.8435 3.45158 17.5304C3.15053 17.2168 3 16.84 3 16.4V3.6C3 3.16 3.15053 2.7832 3.45158 2.4696C3.75213 2.15653 4.1136 2 4.536 2H10.68L15.288 6.8V10H13.752V7.6H9.912V3.6H4.536V16.4H9.144V18H4.536ZM13.9824 12.02L14.808 12.88L11.832 15.96V16.8H12.6384L15.6144 13.72L16.4208 14.56L13.1184 18H10.68V15.46L13.9824 12.02ZM16.4208 14.56L13.9824 12.02L15.096 10.86C15.2368 10.7133 15.416 10.64 15.6336 10.64C15.8512 10.64 16.0304 10.7133 16.1712 10.86L17.5344 12.28C17.6752 12.4267 17.7456 12.6133 17.7456 12.84C17.7456 13.0667 17.6752 13.2533 17.5344 13.4L16.4208 14.56Z",
    fill: "#151B25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/EditSVG.6ef6c550eb87f44583b24a47249d5d93.svg";
export { ForwardRef as ReactComponent };